var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainLayout',{attrs:{"fluid":""}},[_c('h1',{staticClass:"mb-4"},[_c('i',{staticClass:"bx bx-import"}),_vm._v(" "+_vm._s(_vm.$t('import.title'))+" ")]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }